import Reflux from "reflux";

/**
 * Triggered from the logout page towards the session store that a logout should be handled.
 * "LogoutManual" is what happens when the user clicks any Logout Button. It is made public via SessionStore.
 * "Logout" is reserved for internal use inside the UIDispatcher.
 */
export const LogoutActions = {
	Logout: Reflux.createAction(["Logout"]),
	LogoutManual: Reflux.createAction(["LogoutManual"]),
};
